"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowParametersWarning = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var icons_1 = require("../../../gen-src/icons");
var borderRadiusValue = '4px';
var warningStyle = (0, data_catalog_shared_1.cssClass)('parametersWarningBanner', {
    display: 'flex',
    padding: widgets_1.TabStyles.Spacing.MediumSpace,
    borderRadius: "".concat(borderRadiusValue, " 0 0 ").concat(borderRadiusValue),
    backgroundColor: '#fef9ef',
    borderLeft: '4px solid #feca63',
    margin: "".concat(widgets_1.TabStyles.Spacing.LargeSpace, "px ").concat(widgets_1.TabStyles.Spacing.MediumSpace, "px 0 ").concat(widgets_1.TabStyles.Spacing.MediumSpace, "px ")
});
var message = (0, data_catalog_shared_1.cssClass)('parameterWarningMessage', {
    paddingLeft: widgets_1.TabStyles.Spacing.SmallSpace,
});
function FlowParametersWarning() {
    return (react_1.default.createElement("div", { className: warningStyle },
        react_1.default.createElement(icons_1.SvgWarning, null),
        react_1.default.createElement("div", { className: message }, Localize_1.Messages.FlowParametersLineageWarning())));
}
exports.FlowParametersWarning = FlowParametersWarning;
//# sourceMappingURL=FlowParametersWarning.js.map